module.exports = __webpack_public_path__ + "static/img/home_cmp_01.5dfd4ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_cmp_01.png
// module id = cCXw
// module chunks = 9